import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Get session token from localStorage as fallback
        const sessionToken = localStorage.getItem('session_token');
        const headers = sessionToken ? { 'Authorization': `Bearer ${sessionToken}` } : {};
        
        const response = await axios.get(`${API}/auth/me`, {
          withCredentials: true,
          headers
        });
        
        // Verify we got valid user data
        if (!response.data || !response.data.user_id) {
          throw new Error('Invalid user data');
        }
        
        setUser(response.data);
        setIsAuthenticated(true);
      } catch (error) {
        console.log('[ProtectedRoute] Auth check failed:', error.response?.status || error.message);
        localStorage.removeItem('session_token');
        setIsAuthenticated(false);
        navigate('/login');
      }
    };

    checkAuth();
  }, [navigate]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-[#18181B] border-t-transparent"></div>
        </div>
      </div>
    );
  }

  if (isAuthenticated === false) {
    return null;
  }

  return <div data-user={JSON.stringify(user)}>{children}</div>;
}
